module.exports = __webpack_public_path__ + "static/media/item5.1ade3dae.jpg";